import type { ReactElement } from "react";
import { useRef } from "react";
import type { AriaTabPanelProps } from "react-aria";
import { useTabPanel as useAriaTabPanel } from "react-aria";
import type { TabListState } from "react-stately";

/**
 * Tab panel is the content of the Tabs
 * @param state Provided by useTabList
 * @param keepAlive Every tab panels will stay mounted
 * @param props Panel configuration
 */
const useTabPanel = <T extends HTMLElement, U = ReactElement>(
  state: TabListState<U>,
  keepAlive = false,
  props: Partial<AriaTabPanelProps> = {},
) => {
  const ref = useRef<T>(null);
  const { tabPanelProps } = useAriaTabPanel(props, state, ref);

  // TODO: We remove the id if we keep tabs alive because it is wrong due to the way react-aria builds it from the re-rendered state.
  return { ref, tabPanelProps: { ...tabPanelProps, id: keepAlive ? undefined : tabPanelProps.id }, tabIndex: -1 };
};

export { useTabPanel };
